// Rangos de fechas predefinidos para los filtros de fecha (como en HoraSync).

const dosDigitos = (n) => String(n).padStart(2, '0');

/** Fecha local en formato yyyy-MM-dd (el que usan los filtros de fecha). */
export const aIso = (d) =>
  `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}`;

const dia = (y, m, d) => new Date(y, m, d);

export const RANGOS_FECHA = [
  { id: 'hoy', label: 'Hoy', rango: (h) => [h, h] },
  {
    id: 'ultimos7',
    label: 'Últimos 7 días',
    rango: (h) => [dia(h.getFullYear(), h.getMonth(), h.getDate() - 6), h],
  },
  {
    id: 'ultimos30',
    label: 'Últimos 30 días',
    rango: (h) => [dia(h.getFullYear(), h.getMonth(), h.getDate() - 29), h],
  },
  {
    id: 'mes',
    label: 'Mes actual',
    rango: (h) => [
      dia(h.getFullYear(), h.getMonth(), 1),
      dia(h.getFullYear(), h.getMonth() + 1, 0),
    ],
  },
  {
    id: 'mesAnterior',
    label: 'Mes anterior',
    rango: (h) => [
      dia(h.getFullYear(), h.getMonth() - 1, 1),
      dia(h.getFullYear(), h.getMonth(), 0),
    ],
  },
  {
    id: 'trimestre',
    label: 'Trimestre',
    rango: (h) => {
      const m = Math.floor(h.getMonth() / 3) * 3;
      return [dia(h.getFullYear(), m, 1), dia(h.getFullYear(), m + 3, 0)];
    },
  },
  {
    id: 'anio',
    label: 'Año',
    rango: (h) => [dia(h.getFullYear(), 0, 1), dia(h.getFullYear(), 11, 31)],
  },
];

/** Filtro { desde, hasta } (yyyy-MM-dd) de un rango predefinido, o null si no existe. */
export const filtroDeRango = (id, hoy = new Date()) => {
  const r = RANGOS_FECHA.find((x) => x.id === id);
  if (!r) return null;
  const [desde, hasta] = r.rango(dia(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
  return { desde: aIso(desde), hasta: aIso(hasta) };
};
